export const baseDomain =
  'location' in globalThis
    ? (globalThis as any).location.host.split('.').slice(1).join('.')
    : ('envirotoolkit.com' as const);
